import router from '../router'

router.beforeEach( window.auth.createPageGuard( '/login' ) )
